import * as React from 'react';
import { AlternateDestinationCardLarge } from './alternate-destination-card-large';
import { AlternateDestinationCardSmall } from './alternate-destination-card-small';
import { AlternateDestination } from 'src/common/models';

export interface AlternateDestinationsProps {
  title: string;
  destinations?: AlternateDestination[];
  variant?: number;
}

const REQUIRED_DESTINATIONS: number = 2;

export class AlternateDestinationList extends React.Component<AlternateDestinationsProps> {
  public render() {
    const { destinations, title, variant } = this.props;

    if (!destinations || destinations.length < REQUIRED_DESTINATIONS) {
      return null;
    }

    const dests = this.getDestinations(destinations, variant);

    return (
      <li className="uitk-cell uitk-grid all-y-margin-three listing alternate-destinations">
        <h3 className="uitk-type-400">{title}</h3>
        <ol className="uitk-grid no-bullet">
          {dests.map((dest, index) => {
            const paddingClass = index + 1 === REQUIRED_DESTINATIONS ? '' : 'm-r-padding-three l-r-padding-three xl-r-padding-three';

            return (
              <li
                className={`uitk-cell all-y-gutter-three uitk-flex uitk-flex-align-items-stretch s-cell-1-1 m-cell-1-2 l-cell-1-2 xl-cell-1-2 ${paddingClass}`} // tslint:disable max-line-length
                key={`alternate-destination-${index}`}
              >
                {(variant === 1 || variant === 3) && (
                  <AlternateDestinationCardSmall
                    data-stid={`alternate-destination-card-small-${variant}`}
                    destination={dest}
                    position={index}
                    key={index}
                  />
                )}
                {(variant === 2 || variant === 4) && (
                  <AlternateDestinationCardLarge
                    data-stid={`alternate-destination-card-large-${variant}`}
                    destination={dest}
                    position={index}
                    key={index}
                  />
                )}
              </li>
            );
          })}
        </ol>
      </li>
    );
  }

  private getDestinations(destinations: AlternateDestination[], variant: number) {
    // TODO refactor this with sort method
    if (variant === 3 || variant === 4) {
      const destsWithImage = destinations.filter(dest => dest.image);
      const destsWithoutImage = destinations.filter(dest => !dest.image);

      return destsWithImage.concat(destsWithoutImage).slice(0, REQUIRED_DESTINATIONS);
    } else {
      return destinations.slice(0, REQUIRED_DESTINATIONS);
    }
  }
}
